import { lazy } from "react";

export const UserLoginForm = lazy(() => import("./LoginForm/index.form"));
export const UserForgotPassword = lazy(() =>
  import("./ForgotPassword/index.form")
);

export const HeaderSearchForm = lazy(() =>
  import("./HeaderSearchForm/index.form")
);
export const DeleteAccountRequestForm = lazy(() =>
  import("./DeleteAccountForm/index.form")
);
export const UserChangePassword = lazy(() =>
  import("./ChangePasswordForm/index.form")
);

export const UserResetPassword = lazy(() =>
  import("./ResetPassword/index.form")
);
export const UserVerificationForm = lazy(() =>
  import("./Verification/index.form")
);
export const UserSignUpForm = lazy(() => import("./SignupForm/index.form"));
export const UserProfileForm = lazy(() =>
  import("./UserProfileForm/index.form")
);
export const ChangePhoneNumberForm = lazy(() =>
  import("./ChangePhoneNumberForm/index.form")
);
export const RaiseQueryForm = lazy(() => import("./RaiseQueryForm/index.form"));
export const FooterForm = lazy(() => import("./FooterForm/index.form"));
export const MyBiographySearch = lazy(() =>
  import("./MyBiographySearch/index.form")
);

export const SupportForm = lazy(() => import("./SupportForm/index.form"));
export * from "./CreateMemorialsForms";
export const AdvanceSearchForm = lazy(() =>
  import("./AdvanceSearchForm/index.form")
);

export const ShareBiographyForm = lazy(() =>
  import("./ShareBiographyForm/index.form")
);

export const OtpVerificationForm = lazy(() =>
  import("./OtpVerificationForm/index.form")
);
export const ReportMemorialForm = lazy(() =>
  import("./ReportMemorialForm/index.form")
);

export const DownloadableMemoriesForm = lazy(() =>
  import("./DownloadedMemoriesForm/index.form")
);

export const PaymentForm = lazy(() => import("./PaymentForm/index.form"));
export const CommentForm = lazy(() => import("./CommentForm/index"));
export const SavedCardForm = lazy(() => import("./SavedCardForm/index.form"));
export const CouponForm = lazy(() => import("./CouponForm/index"));
export const ForgotPasswordForm = lazy(() =>
  import("./ForgotPassword/index.form")
);
